import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

import config from 'app-config';
import pjson from '../package.json';

export default function initializeSentry() {
  if (config.useSentry) {
    Sentry.init({
      dsn: process.env.PWA_SENTRY_DSN,
      release: pjson.version,
      integrations: [new BrowserTracing()],
      tracesSampleRate: 0.2,
      ignoreErrors: config.ignoreErrors,
    });
  }
}
